export const AudienceSection = () => {
  const audiences = ["ERPs e software houses B2B", "E-commerces multi-CNPJ", "Escritórios contábeis e BPO", "SaaS com NFe white-label"]

  return (
    <section className="bg-slate-850 py-14 text-white">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <h2 className="text-2xl font-bold">Para quem é</h2>
        <ul className="mt-6 grid gap-3 sm:grid-cols-2">
          {audiences.map((item) => (
            <li key={item} className="rounded-lg bg-white/5 px-4 py-3 text-sm text-slate-100">
              {item}
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
